export default "__VITE_ASSET__BDtiPnTZ__"